import { AttachmentPreviewMethod, AttachmentSelectionSource } from 'owa-attachment-data';
import { type SaveToCloudStatus } from 'owa-attachment-savetocloud/lib/utils/SaveToCloudStatus';
import EventEmitter from 'owa-event-emitter';
import { type MeetingMessageAddToCalendarStatus } from 'owa-meeting-message-utils';
import type GetAttachmentTextPreviewReadMode from 'owa-service/lib/contract/GetAttachmentTextPreviewReadMode';
import getInitialSxSViewState from 'owa-sxsdata/lib/utils/getInitialSxSViewState';
import { createStore } from 'owa-satcheljs';
import type { SxSStoreData, SxSStore } from './schema/SxSStore';
import { SXSID_MAIN_WINDOW, SxSCustomization } from './schema/SxSStore';
function createInitialStoreData(): SxSStoreData {
    const initialStoreData: SxSStoreData = {
        shouldShow: false,
        viewState: getInitialSxSViewState(),
        extendedViewState: {
            previewMode: AttachmentPreviewMethod.Unsupported,
            attachmentId: null,
            selectionSource: AttachmentSelectionSource.MailList,
            isCloudy: false,
            saveToCloudStatus: 0,
            textPreviewReadMode: 0,
            textPreviewCustomEncoding: undefined,
            itemId: null,
            isDraft: false,
            isSummarizationSupported: false,
        },
        customPreviewState: null,
        eventManager: new EventEmitter(),
        pendingPreviewOperation: null,
        pendingNavigation: null,
        readingPaneState: null,
        composeId: null,
        customization: SxSCustomization.Mail,
        isInvisible: true,
        shouldUseFakeRightHandSide: false,
        isUsingFakeRightHandSide: false,
        attachmentViewStateIdFromListView: null,
        sessionPreviewCount: 0,
        sessionStartTime: 0,
        meetingMessageAddToCalendarStatus: 1,
        sigsInfo: null,
    };
    initialStoreData.viewState.previewPane = null;
    return initialStoreData;
}

const defaultStore: SxSStore = {
    sxsStoreMapping: new Map<string, SxSStoreData>([]),
};
export const getStore: () => SxSStore = createStore<SxSStore>('sxsStore', defaultStore);

export default function getOrCreateSxSStoreData(sxsId?: string | null): SxSStoreData {
    const store = getStore();
    sxsId = sxsId || SXSID_MAIN_WINDOW;
    if (!store.sxsStoreMapping.has(sxsId)) {
        const initialStoreData: SxSStoreData = createInitialStoreData();
        store.sxsStoreMapping.set(sxsId, initialStoreData);
    }
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion  -- (https://aka.ms/OWALintWiki)
     * Non-null assertions are dangerous, as they can hide bugs from strictness checks. Please remove this usage or replace this line with a justification.
     *	> Forbidden non-null assertion. */
    return store.sxsStoreMapping.get(sxsId)!;
}
